import axios from "axios";
import Apiconnection from "../utils/Apiconnection";
import {
  getUnreadCount,
  normalizeNotifications,
} from "../utils/notifications";

export const buildBearerTokenHeaders = (token) => ({
  "Content-Type": "application/json",
  token: `Bearer ${token}`,
});

export const requestToMarkReady = ({
  bookingRequestId,
  token,
  client = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  }),
}) =>
  client.post(
    "request-to-mark-ready",
    { bookingRequestId },
    {
      headers: buildBearerTokenHeaders(token),
    }
  );

export const carReadyStatusChange = ({
  bookingRequestId,
  readyStatus = "Ready",
  token,
  client = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  }),
}) =>
  client.post(
    "car-ready-status-change",
    { bookingRequestId, readyStatus },
    {
      headers: buildBearerTokenHeaders(token),
    }
  );

export const markVehicleReadyAndNotifyCustomer = async ({
  bookingRequestId,
  token,
  client = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  }),
}) => {
  const readyResponse = await requestToMarkReady({
    bookingRequestId,
    token,
    client,
  });

  const notificationResponse = await carReadyStatusChange({
    bookingRequestId,
    readyStatus: "Ready",
    token,
    client,
  });

  return {
    readyResponse,
    notificationResponse,
  };
};

export const savePushSubscription = ({
  subscription,
  token,
  endpoint = process.env.REACT_APP_PUSH_SUBSCRIPTION_ENDPOINT ||
    "push-subscription-save",
  client = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  }),
}) =>
  client.post(
    endpoint,
    { subscription },
    {
      headers: buildBearerTokenHeaders(token),
    }
  );

export const fetchNotifications = async ({
  page = 1,
  limit = 10,
  client = Apiconnection,
} = {}) => {
  const response = await client.post("notification-list", {
    page,
    limit,
  });
  const totalCount =
    response?.data?.totalCount ??
    response?.data?.data?.totalCount ??
    response?.data?.data?.pagination?.totalCount ??
    0;
  const rawNotifications =
    response?.data?.data?.notifications || response?.data?.data || [];
  const notifications = normalizeNotifications(rawNotifications);

  return {
    page,
    limit,
    totalCount,
    notifications,
    unreadCount: getUnreadCount(notifications),
  };
};

export const markNotificationAsRead = (notificationId) =>
  Apiconnection.post("notification-status-change", {
    notificationId,
    isRead: true,
  });

export const markNotificationsAsRead = (
  notificationIds = [],
  client = Apiconnection
) =>
  Promise.all(
    notificationIds.map((notificationId) =>
      client.post("notification-status-change", {
        notificationId,
        isRead: true,
      })
    )
  );

export const deleteNotification = (notificationId) =>
  Apiconnection.post("notification-delete", {
    notificationId,
  });
